import { useSalesTermWithTime } from "@/components/features/items/edit/_shared/ui/components/main/questions/sales-term-with-time/hooks";

import { useProductDayTripPlanFormModelContext } from "../../../../context";

export const useDayTripPlanSaleTerm = () => {
	const { viewModel, onSetViewModel } = useProductDayTripPlanFormModelContext();
	const { saleTypeForTerm, saleStart, saleEnd, saleStartTime, saleEndTime, stayableStart, stayableEnd } = viewModel;

	return useSalesTermWithTime({
		saleTypeForTerm,
		saleStart,
		saleEnd,
		saleStartTime,
		saleEndTime,
		stayableStart,
		stayableEnd,
		onSetViewModel,
	});
};
